/** @jsxRuntime classic */
/** @jsx jsx */
import {css, jsx} from "@emotion/core";
import React from 'react';
import {Button, Theme} from "@ice/components";
import {IconInfo} from "../util/IconInfo";
import {XIcon} from "../ui/XIcon";
import LayerPanelList from "./LayerPanelList";
import DatasetListPanel from "./DatasetListPanel";
import {getAppState, isDevMode} from "../store/AppState";
import DevOptionsPanel from "./DevOptionsPanel";


export type LeftToolbarSectionConfig = {
    content: JSX.Element;         // content for the drawer section
    icon: IconInfo;             // icon to represent the section of the drawer
    title?: string;             // title text applied to the section
    tooltip: string;            // tooltip for the icon
};

const LEFT_BAR_SECTIONS: Array<LeftToolbarSectionConfig> = [
    {
        icon: IconInfo.LAYERS,
        tooltip: "Layers",
        title: "Layers",
        content: <LayerPanelList />,
    },
    {
        icon: IconInfo.FILE,
        tooltip: "Data",
        title: "Data",
        content: <DatasetListPanel />,
    },
];

if (isDevMode()) {
    LEFT_BAR_SECTIONS.push({
        icon: IconInfo.DEVELOPMENT,
        tooltip: "Dev",
        title: "Dev",
        content: <DevOptionsPanel />,
    });
}


interface LeftToolboxProps {
}


interface LeftToolboxState {
    isOpen: boolean;
    selectedSectionIndex: number;
}


export default class LeftToolbox extends React.Component<LeftToolboxProps, LeftToolboxState> {

    private ziggy = true;

    constructor(props: LeftToolboxProps) {
        super(props);
        this.state = {
            isOpen: false,
            selectedSectionIndex: 0
        };
    }

    refresh = () => {
        this.ziggy = !this.ziggy;
        this.forceUpdate();
    }

    render(): React.ReactNode {
        let isOpen = this.state.isOpen;

        let sectionButtons = [];
        for (let i = 0; i < LEFT_BAR_SECTIONS.length; i++) {
            const section = LEFT_BAR_SECTIONS[i];
            const isSelected = isOpen && this.state.selectedSectionIndex === i;
            sectionButtons.push(
                <Button minimal nopad onClick={() => {
                    this.setState({isOpen: true, selectedSectionIndex: i});
                }} css={(theme: Theme) => css`
                      margin-top: ${i > 0 ? "0.5rem" : "0"};
                      border-radius: 0;
                      border: ${isOpen ? "0" : "1px"} solid ${theme.dark ? "rgba(128, 128, 128, 0.4)" : "rgba(128, 128, 128, 0.25)"}; 
                      background-color: ${isSelected ? theme.textColor.faint : (theme.dark? "rgba(0, 0, 0, 0.8)": "rgba(255, 255, 255, 0.8)")};
                      &:hover {
                        ${!isSelected && `background-color: ${theme.datePicker.hover.backgroundColor};`}
                      }
                `}>
                    <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "0.25em 0.5em"}}>
                        <XIcon icon={section.icon} iconSize={"1.5rem"} css={(theme: Theme) => css`
                             fill: ${isSelected ? theme.backgroundColor.default : theme.textColor.default};
                        `} />
                        <span className={"noselect"} css={(theme: Theme) => css`
                              font-size: 0.85em;
                              color: ${isSelected ? theme.backgroundColor.default : theme.textColor.default};
                        `}>
                            {section.title}
                        </span>
                    </div>
                </Button>
            );
        }

        let sectionToRender = null;
        if (isOpen) {
            let selectedSection = LEFT_BAR_SECTIONS[this.state.selectedSectionIndex];
            let appState = getAppState();

            sectionToRender = (
                <div style={{display: "flex", flexDirection: "column", alignContent: "center", height: "100%"}}>
                    <div className={"header noselect"} style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        {selectedSection.title}
                        <span style={{flexGrow: 1}} />
                        <XIcon icon={IconInfo.CLOSE}
                               iconSize={"1rem"}
                               onClick={() => this.setState({isOpen: false})}
                               css={(theme: Theme) => css`fill: ${theme.textColor.default}; cursor: pointer;`}
                        />
                    </div>
                    <div
                        key={`ltl_${appState.getLayerCount()}`}
                        style={{display: "flex", flexDirection: "column", flex: 1, minHeight: 0}}
                    >
                        { selectedSection.content }
                    </div>
                </div>
            )
        }

        return (
            <div key={`lpl_${this.ziggy}`} className={"left-toolbox"}>
                <div className={"content"} style={{width: isOpen ? "400px" : 0}} css={(theme: Theme) => css`
                  background-color: ${theme.backgroundColor.default};
                `}>
                    {sectionToRender}
                </div>
                <div className={"section-buttons"}>
                    <div style={{display: "flex", flexDirection: "column", padding: "0.2rem"}} css={(theme: Theme) => css`
                          margin-left: ${isOpen ? "0" : "0.25em"};
                          background-color: ${isOpen ? theme.backgroundColor.default : "rgba(0, 0, 0, 0)"};
                          border-top: ${isOpen ? "1px solid rgba(128, 128, 128, 0.3)" : "none"};
                          border-right: ${isOpen ? "1px solid rgba(128, 128, 128, 0.3)" : "none"};
                          border-bottom: ${isOpen ? "1px solid rgba(128, 128, 128, 0.3)" : "none"};
                    `}>
                        {sectionButtons}
                    </div>
                </div>
            </div>
        );
    }

}

